export class ExpandCard {
    private root: HTMLElement;

    private button: HTMLButtonElement;

    private content: HTMLElement;

    constructor(root: HTMLElement) {
        this.root = root;
        this.button = root.querySelector('button.esc-expand__trigger')!;
        this.content = root.querySelector('.esc-expand__content')!;
        if (this.root.classList.contains('is-open')) {
            this.toggle();
        }

        this.button.addEventListener('click', () => this.toggle());
    }

    private setState(open: boolean) {
        this.button.setAttribute('aria-expanded', String(open));
        this.content.setAttribute('aria-hidden', String(!open));
    }

    toggle() {
        const expanded = this.button.getAttribute('aria-expanded') === 'true';
        this.setState(!expanded);
    }

    static init() {
        document.querySelectorAll<HTMLElement>('.esc-expand').forEach((el) => new ExpandCard(el));
    }
}
